export default __webpack_public_path__ + "static/media/certificateShadow.9f7b6e5b.png";